import { Controller } from "@hotwired/stimulus"

/*
Mostra/oculta painéis condicionalmente conforme o valor de um campo (tipicamente um select).

Exemplo de uso:
  <div data-controller="toggler" data-toggler-show-when-value="Sim">
    <select data-toggler-target="trigger" data-action="toggler#refresh"> ... </select>
    <div data-toggler-target="panel"> ... </div>
  </div>

O(s) painel(is) aparecem quando o valor do trigger está na lista `show-when`
(valores separados por vírgula); caso contrário recebem a classe `hidden`.
*/

export default class extends Controller {
  static targets = ["trigger", "panel"]
  static values = { showWhen: String }

  connect() {
    this.refresh()
  }

  refresh() {
    const valores = this.showWhenValue.split(",").map(v => v.trim())
    const visivel = this.hasTriggerTarget && valores.includes(this.triggerTarget.value)

    this.panelTargets.forEach(panel => panel.classList.toggle("hidden", !visivel))
  }
}
